import React from 'react';
import { useSelector } from 'react-redux';
import { stampDialogVisibility } from '../../../Redux/StampDialogSlice';
import StampDialog from './StampDialog';

/**
 * Component that shows a configurable information dialog.
 */
export default () => {
    const stampDialogVisible = useSelector(stampDialogVisibility);

    if (!stampDialogVisible) {
      return <></>;
    }

    return <StampDialog />;
};
